// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__57rU3","form_box":"Login_form_box__R4a1-","input_box":"Login_input_box__AyD20","check_box":"Login_check_box__MqBSf","submit_btn":"Login_submit_btn__UPYDN"};